"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var reader_1 = require("./reader");
exports.QRReader = reader_1.QRReader;
var view_1 = require("./view");
exports.QRCode = view_1.QRCode;
var modal_1 = require("./modal");
exports.ModalQR = modal_1.ModalQR;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/qr/index.js
// module id = 2247
// module chunks = 0